import base from "@/store/utils/api-route/base";

const customerAPI = {
	list: `${base.meta}list_data_konsumen`,
	listV2: `${base.meta}list_data_konsumen_v2`,
	create: `${base.konsumen}tambah_customer_baru_v2`,
	detail: `${base.meta}detail_data_konsumen`,
	update: {
		index: `${base.konsumen}/update`, //update/{id}
		outlet: `${base.konsumen}update_outlet_terdaftar_customer`,
		nama: `${base.konsumen}update_nama_customer`,
		jenisKelamin: `${base.konsumen}update_jenis_kelamin_customer`,
		telepon: `${base.konsumen}update_telp_customer`,
		instansi: `${base.konsumen}update_instansi_customer`,
		tanggalLahir: `${base.konsumen}update_tanggal_lahir_customer`,
		agama: `${base.konsumen}update_agama_customer`,
		email: `${base.konsumen}update_email_customer`,
	},
	delete: `${base.konsumen}hapus_customer`,
	topFive: `${base.meta}list_top_5_layanan`,

	alamat: {
		list: `${base.meta}list_data_alamat_konsumen`,
		create: `${base.konsumen}tambah_alamat_customer`,
		update: `${base.konsumen}update_alamat_customer`,
		delete: `${base.konsumen}delete_alamat_customer`,
	},
	import: `${base.konsumen}import_konsumen`,
	// export: `${base.konsumen}export_konsumen`,
	importTrack: `${base.konsumen}track_import_konsumen`,
	exportTrack: `${base.konsumen}track_export_konsumen`,
	deleteExport: `${base.konsumen}delete_file_export_konsumen`,

	paketDeposit: {
		list: {
			paket: `${base.meta}list_paket_deposit_konsumen`,
			transaksi: `${base.meta}paket_deposit_rekap_transaksi`,
		},
		detail: `${base.meta}detail_pembelian_deposit`
	},

	epayment: {
		list: `${base.meta}list_riwayat_pemakaian_epayment`,
		detail: `${base.meta}detail_pembelian_epayment`,
	},
	export: {
		job: `${base.export}job`,
		track: `${base.export}track_redis_job`,
		delete: {
			cluster: `${base.export}delete_cluster_redis_job`,
			master: `${base.export}delete_master_redis_job`,
		},
	},
	riwayat: `${base.meta}riwayat_customer`
}

export default customerAPI